import { CommonTableRequestType } from 'src/models/Table';

export enum AdminTableEnum {
  CAMPAIGNS_MANAGEMENT = 'campaigns.management',
  CAMPAIGNS_FUNDREQUESTS = 'campaigns.fundRequests',
  CAMPAIGNS_REFERRALS = 'campaigns.referrals',
  CAMPAIGNS_TRANSACTIONS = 'campaigns.transactions',
  CAMPAIGNS_TRANSACTIONS_CHARGEBACKS = 'campaigns.transactionsChargebacks',
  CAMPAIGNS_EXPORT_DONATIONS = 'campaigns.exportDonations',
  CAMPAIGNS_REQUEST_DETAILS = 'campaigns.requestDetails',
  EXPERIENCE_TEMPLATES = 'campaigns.experienceTemplates',
  MANAGED_CAMPAIGNS = 'campaigns.managedCampaigns',

  AFFILIATES_INDEX = 'affiliates.index',
  AFFILIATES_PAYMENTS = 'affiliates.payments',

  IMPORT_DONATIONS = 'importDonations',

  ORGANIZATIONS_MANAGEMENT = 'organizations.management',
  ORGANIZATIONS_ADMINISTRATORS = 'organizations.administrators',
  ORGANIZATIONS_IMPORT = 'organizations.import',

  CONFIGURATION_USERS = 'configuration.users',
  CONFIGURATION_SUBSCRIPTIONS_PLANS = 'configuration.subscriptionsPlans',
  CONFIGURATION_PROMO_CODES = 'configuration.promoCodes',
  CONFIGURATION_FEES = 'configuration.fees',
  CONFIGURATION_RAFFLE_SWEEPS_TIP = 'configuration.raffleSweepsTip',
  CONFIGURATION_FUNDING = 'configuration.funding',
  CONFIGURATION_PLEDGE_FUNDING = 'configuration.pledgeFunding',
  CONFIGURATION_ERROR_LOGS = 'configuration.errorLogs',
  CONFIGURATION_AUDIT = 'configuration.audit',

  INTEGRATIONS_SYSTEM = 'integrations.system',
  INTEGRATIONS_REST_API = 'integrations.restApi',

  ADMIN_PARTNER_CAMPAIGNS = 'partner.campaigns',
  ADMIN_PARTNER_ORGANIZATIONS = 'partner.organizations',
  ADMIN_PARTNER_ORGANIZATIONS_ADMINISTRATORS = 'partner.organizationsAdministrators',
  ADMIN_PARTNER_TRANSACTIONS = 'partner.transactions',
  ADMIN_PARTNER_TRANSACTIONS_CHARGEBACKS = 'partner.transactionsChargebacks',
  ADMIN_PARTNER_USERS = 'partner.users',
  ADMIN_PARTNER_ADMINISTRATORS = 'partner.administrators',
  ADMIN_PARTNER_API = 'partner.api',
  ADMIN_PARTNER_FUNDING = 'partner.funding',
  ADMIN_PARTNER_WEBHOOKS = 'partner.webhooks',
  ADMIN_PARTNER_AUDIT = 'partner.audit',

  PARTNERS_MANAGEMENT = 'partners.management',
  PARTNERS_SPLIT_EXCEPTIONS = 'partners.splitExceptions',
  PARTNERS_SETUP = 'partners.setup',

  PARTNER_ADMINISTRATORS = 'partnerAdministrators',
  ADMIN_PARTNER_EXPERIENCE_TEMPLATES = 'partner.experienceTemplates',
}

export type AdminTableGetListStartFilterType = CommonTableRequestType & {
  userID?: number;
  RequestParams?: { PermanentUrl: string };
};
